class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        return this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  async onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      try {
        const response = await fetch(
          `${routes.cart_url}?section_id=cart-drawer`
        );
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        const response = await fetch(
          `${routes.cart_url}?section_id=main-cart-items`
        );
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      } catch (e) {
        console.error(e);
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const ReducedBody = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget =
      event.currentTarget instanceof CartRemoveButton ? "clear" : "change";

    try {
      let response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body },
      });
      let state = await response.text();
      let parsedState = JSON.parse(state);
      if (parsedState.errors) {
        response = await fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body: ReducedBody },
        });
        state = await response.text();
        parsedState = JSON.parse(state);
      }

      CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        // if (parsedState.errors) {
        //   quantityElement.value = quantityElement.getAttribute("value");
        //   this.updateLiveRegions(line, parsedState.errors);
        //   return;
        // }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
      });

      CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: parsedState,
        variantId: variantId,
      });
      // --- ADD YOUR CUSTOM EVENT CODE HERE ---
      /**
       * Dispatches a standard DOM event that other scripts can easily listen for.
       * bubbles: true - Allows listening on `document` instead of just this element.
       * detail - Contains the full cart data from the API response.
       */
      const domEvent = new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: parsedState, // We pass the entire cart object as the payload
        },
      });
      this.dispatchEvent(domEvent);
      // --- END OF NEW CODE ---
    } catch (error) {
      this.querySelectorAll(".loading__spinner").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
      document.querySelector("coupons-box").copyCouponsToAttributes();
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce(async (event) => {
            const body = JSON.stringify({ note: event.target.value });
            try {
              await fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                ...{ body },
              });
              CartPerformance.measureFromEvent(
                "note-update:user-action",
                event
              );
            } catch (error) {
              console.error("Failed to update cart note:", error);
            }
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
let showCouponState;
class CouponsBox extends HTMLElement {
  constructor() {
    super();
    this.opener = this.querySelector(".coupons-box-opener-text");
    this.couponContainer = this.querySelector(".coupon-container");
    if (
      showCouponState ||
      this.getAttribute("data-show-coupons-box") == "true"
    ) {
      this.couponContainer.classList.remove("hidden");
      showCouponState = true;
    } else {
      this.opener.classList.remove("hidden");
    }
    this.opener.addEventListener("click", () => {
      showCouponState = true;
      this.opener.classList.add("hidden");
      this.couponContainer.classList.remove("hidden");
    });

    this.applyButton = this.querySelector(".coupon-apply-button");
    this.applyButtonLoadingSpinner = this.querySelector(
      ".coupon-apply-button .loading__spinner"
    );

    this.applyButton.addEventListener("click", () => {
      this.applyButtonLoadingSpinner.classList.remove("hidden");
    });

    this.button = this.querySelector("button");
    this.input = this.querySelector("#coupon_input");
    this.input.value == ""
      ? this.button.classList.add("disabled")
      : this.button.classList.remove("disabled");
    this.input.addEventListener("input", () => {
      this.input.value == ""
        ? this.button.classList.add("disabled")
        : this.button.classList.remove("disabled");
    });

    // need refactoring after appling more than one code becomes available
    if (this.querySelector(".code-tag")) {
      this.removeButton = this.querySelector(".code-tag button");
      this.removeButtonLoadingSpinner = this.querySelector(
        ".code-tag .loading__spinner"
      );
      this.removeButton.addEventListener("click", () => {
        this.removeButtonLoadingSpinner.classList.remove("hidden");
      });
    }

    if (this.button && this.input) {
      this.button.addEventListener("click", async (event) => {
        event.preventDefault();
        await this.applyCoupons(this.input.value);
      });

      // Optional: apply on Enter
      this.input.addEventListener("keydown", async (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          await this.applyCoupons(this.input.value);
        }
      });
    }

    // Event delegation so it still works after sections re-render
    this.addEventListener("click", async (e) => {
      const removeEl = e.target.closest(".remove");
      if (!removeEl) return;

      e.preventDefault();

      // Find the code for this tag
      const codeTag = removeEl.closest(".code-tag");
      const codeTitle = codeTag?.querySelector(".code-title");
      const codeToRemove = this.normalizeCode(codeTitle?.textContent || "");

      if (!codeToRemove) return;

      // Collect all current codes (input + DOM), then exclude the one removed
      const remaining = this.collectCodes(this.input?.value, [codeToRemove]);

      await this.applyCouponsFromList(remaining);
    });
  }

  /** Normalize a single code: trim, UPPERCASE, remove non [A-Z0-9_-] */
  normalizeCode(code) {
    if (!code) return "";
    return code
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9_-]/g, "");
  }

  /** Parse a string with possibly multiple codes (comma/space/semicolon/pipe) */
  parseCodesFromString(str) {
    if (!str) return [];
    return str
      .split(/[,\s;|]+/)
      .map((c) => this.normalizeCode(c))
      .filter((c) => c.length > 0);
  }

  /**
   * Collect codes from input + DOM (.applied-codes .code-title)
   * `exclude` is an array of codes to remove from the final set
   */
  collectCodes(extraInputValue, exclude = []) {
    const set = new Set();

    // From input (support multiple)
    this.parseCodesFromString(extraInputValue).forEach((c) => set.add(c));

    // From already-rendered tags
    this.querySelectorAll(".applied-codes .code-tag .code-title").forEach(
      (el) => {
        const c = this.normalizeCode(el.textContent || "");
        if (c) set.add(c);
      }
    );

    // Apply exclusions
    exclude.map((c) => this.normalizeCode(c)).forEach((c) => set.delete(c));

    return Array.from(set);
  }

  /** Fallback copy of CartItems.getSectionsToRender() */
  getSectionsToRenderFallback() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
    ].filter((s) => s.section);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  async applyCoupons(inputValue) {
    const codes = this.collectCodes(inputValue);
    return this.applyCouponsFromList(codes);
  }

  async applyCouponsFromList(codes) {
    // Prefer nearby cart-items to reuse its sections definition if available
    const cartItems =
      this.closest("cart-items") ||
      this.closest("cart-drawer-items") ||
      document.querySelector("cart-items") ||
      document.querySelector("cart-drawer-items");

    const sectionsToRender = cartItems?.getSectionsToRender
      ? cartItems.getSectionsToRender()
      : this.getSectionsToRenderFallback();

    const discountString = codes.join(","); // "" clears discounts

    const body = JSON.stringify({
      discount: discountString,
    });

    const mainCart =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");

    try {
      mainCart?.classList.add("cart__items--disabled");

      const firstResponse = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body,
      });

      const firstStateText = await firstResponse.text();
      const firstParsedState = JSON.parse(firstStateText);
      const applicableDiscounts = firstParsedState.discount_codes.filter(
        (discount) => discount.applicable
      );
      if (
        firstParsedState.discount_codes.length > 0 &&
        applicableDiscounts.length == 0
      ) {
        open_invalidCouponAlertModal();
      }
      const bodyToCopyDiscountsToAttributes = JSON.stringify({
        attributes: {
          codes: applicableDiscounts.map((discount) =>
            discount.code.toUpperCase()
          ),
        },
        sections: sectionsToRender.map((s) => s.section),
        sections_url: window.location.pathname,
      });
      const secondResponse = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: bodyToCopyDiscountsToAttributes,
      });
      const secondStateText = await secondResponse.text();
      const secondParsedState = JSON.parse(secondStateText);
      console.log(secondParsedState);

      // Re-render sections like CartItems.updateQuantity
      sectionsToRender.forEach((section) => {
        const mount =
          document
            .getElementById(section.id)
            ?.querySelector(section.selector) ||
          document.getElementById(section.id);
        if (mount && secondParsedState.sections?.[section.section]) {
          mount.innerHTML = this.getSectionInnerHTML(
            secondParsedState.sections[section.section],
            section.selector
          );
        }
      });

      // Publish so other parts of the cart react (optional)
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "coupons-box",
          cartData: secondParsedState,
        });
      }

      // --- ADD YOUR CUSTOM EVENT CODE HERE ---
      /**
       * Dispatches a standard DOM event that other scripts can easily listen for.
       * bubbles: true - Allows listening on `document` instead of just this element.
       * detail - Contains the full cart data from the API response.
       */
      const domEvent = new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: secondParsedState, // We pass the entire cart object as the payload
        },
      });
      document.dispatchEvent(domEvent);
      // --- END OF NEW CODE ---

      // Optional UX: clear input after apply
      this.input && (this.input.value = "");
    } catch (err) {
      console.error("Failed to apply coupons:", err);
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      if (errors)
        errors.textContent =
          window.cartStrings?.error || "Error updating cart.";
    } finally {
      mainCart?.classList.remove("cart__items--disabled");
    }
  }

  async copyCouponsToAttributes() {
    // Prefer nearby cart-items to reuse its sections definition if available
    const cartItems =
      this.closest("cart-items") ||
      this.closest("cart-drawer-items") ||
      document.querySelector("cart-items") ||
      document.querySelector("cart-drawer-items");

    const sectionsToRender = cartItems?.getSectionsToRender
      ? cartItems.getSectionsToRender()
      : this.getSectionsToRenderFallback();

    // const body = JSON.stringify({
    //   discount: discountString,
    // });

    const mainCart =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");

    try {
      mainCart?.classList.add("cart__items--disabled");

      const firstResponse = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        //body,
      });

      const firstStateText = await firstResponse.text();
      const firstParsedState = JSON.parse(firstStateText);
      const applicableDiscounts = firstParsedState.discount_codes.filter(
        (discount) => discount.applicable
      );
      const bodyToCopyDiscountsToAttributes = JSON.stringify({
        attributes: {
          codes: applicableDiscounts.map((discount) =>
            discount.code.toUpperCase()
          ),
        },
        sections: sectionsToRender.map((s) => s.section),
        sections_url: window.location.pathname,
      });
      const secondResponse = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: bodyToCopyDiscountsToAttributes,
      });
      const secondStateText = await secondResponse.text();
      const secondParsedState = JSON.parse(secondStateText);
      console.log(secondParsedState);

      // Re-render sections like CartItems.updateQuantity
      sectionsToRender.forEach((section) => {
        const mount =
          document
            .getElementById(section.id)
            ?.querySelector(section.selector) ||
          document.getElementById(section.id);
        if (mount && secondParsedState.sections?.[section.section]) {
          mount.innerHTML = this.getSectionInnerHTML(
            secondParsedState.sections[section.section],
            section.selector
          );
        }
      });

      // Publish so other parts of the cart react (optional)
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "coupons-box",
          cartData: secondParsedState,
        });
      }

      // --- ADD YOUR CUSTOM EVENT CODE HERE ---
      /**
       * Dispatches a standard DOM event that other scripts can easily listen for.
       * bubbles: true - Allows listening on `document` instead of just this element.
       * detail - Contains the full cart data from the API response.
       */
      const domEvent = new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: secondParsedState, // We pass the entire cart object as the payload
        },
      });
      document.dispatchEvent(domEvent);
      // --- END OF NEW CODE ---

      // Optional UX: clear input after apply
      this.input && (this.input.value = "");
    } catch (err) {
      console.error("Failed to apply coupons:", err);
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      if (errors)
        errors.textContent =
          window.cartStrings?.error || "Error updating cart.";
    } finally {
      mainCart?.classList.remove("cart__items--disabled");
    }
  }
}

// Define once
if (!customElements.get("coupons-box")) {
  customElements.define("coupons-box", CouponsBox);
}
document.querySelector("coupons-box").copyCouponsToAttributes();
